/**
 * 還原對話面板的訊息列（純函式）。
 *
 * 資料庫存的是純文字的 user／model 訊息，事件卡片（設定變更、確認生成、追問）
 * 當初就沒有被持久化，所以還原出來一律是文字泡泡 —— 呈現我們真的有的東西，
 * 不假裝重建那些互動狀態。
 */

/** 開場白：沒有任何歷史訊息時，對話面板一開始顯示的內容 */
export const WELCOME_MESSAGE =
  '你好！我是你的 AI 生成助理。請告訴我你想怎麼調整這張圖片，確認後即可重新生成。';

export interface RestorableChatMessage {
  role: 'user' | 'model';
  content: string;
}

export interface RestoredChatBubble {
  id: string;
  type: 'user' | 'assistant-text';
  content: string;
}

/**
 * 把保存下來的訊息組成對話面板的初始訊息列。
 * 開場白永遠在最前面（與全新的對話一致），後面接還原出來的訊息、順序照原本。
 */
export function buildRestoredChatMessages(
  messages: RestorableChatMessage[] | undefined
): RestoredChatBubble[] {
  const welcome: RestoredChatBubble = {
    id: 'welcome',
    type: 'assistant-text',
    content: WELCOME_MESSAGE,
  };

  const restored = (messages ?? [])
    .filter((msg) => typeof msg.content === 'string' && msg.content.trim() !== '')
    .map((msg, index) => ({
      id: `restored-${index}`,
      type: msg.role === 'user' ? ('user' as const) : ('assistant-text' as const),
      content: msg.content,
    }));

  return [welcome, ...restored];
}
